import { BLOG_ITEMS_RECEIVED } from '../constants/blog';

export default function blog(state = {}, action) {
  switch (action.type) {
    case BLOG_ITEMS_RECEIVED:
      return {
        ...state,
        sections: {
          ...state.sections,
          [action.section]: action.items,
        },
      };
    default:
      return state;
  }
}
